export const DEG2RAD = Math.PI / 180;
export const RAD2DEG = 180 / Math.PI;
export const RAD_360 = 2 * Math.PI;
export const RAD_180 = Math.PI;
export const RAD_90 = Math.PI / 2;
export const RAD_45 = Math.PI / 4;
const ZERO_ZERO = [0, 0];
export function distanceBetweenPoints(a, b) {
  const diffX = a[0] - b[0];
  const diffY = a[1] - b[1];
  return Math.sqrt(diffX ** 2 + diffY ** 2);
}
export function lineMidpoint([x1, y1], [x2, y2]) {
  return [(x1 + x2) / 2, (y1 + y2) / 2];
}
/**
 * Normalize radians to be between positive 0 and 2*Pi.
 *
 * @param radians
 */

export function normalizeRadians(radians) {
  let mod = radians % RAD_360;
  if (mod < 0) mod += RAD_360;
  return mod;
}
export function polarToCartesian(center, radius, angleInDegrees) {
  const angleInRadians = angleInDegrees * DEG2RAD;
  return [center[0] + radius * Math.cos(angleInRadians), center[1] + radius * Math.sin(angleInRadians)];
}
export function rotatePoint([x, y], theta, [cx, cy] = ZERO_ZERO) {
  const rad = theta * DEG2RAD;
  const cos = Math.cos(rad);
  const sin = Math.sin(rad);
  const x1 = x - cx;
  const y1 = y - cy;
  const next = [x1 * cos - y1 * sin, x1 * sin + y1 * cos];
  next[0] += cx;
  next[1] += cy;
  return next;
}
/**
 * Returns the inner angle in degrees of an circle segment, from at `[x, 0]`
 * counterclockwise to `point`.
 */

export function rotationFromPoint(point, center) {
  const dx = point[0] - center[0];
  const dy = point[1] - center[1];
  const rad = Math.atan2(-dy, dx);
  return normalizeRadians(rad) * RAD2DEG;
}